export default {
  '信息': 'Info',
  '密码': 'Password',
  '头像': 'Avatar',

  '我的信息': 'My info',

  '昵称': 'Nickname',
  '邮箱': 'Email',
  '简介': 'Introduce',
  '昵称不能为空': 'Nickname dont empty',
  '邮箱不能为空': 'Email dont empty',
  '信息更新成功': 'Info update successfully',

  '修改头像注意': 'Updata avatar tip',
  '选择头像提交后将会自动提交修改头像为选择头像': 'Avatar will auto upload',
  '选择头像': 'Select avatar',
  '更新头像成功': 'Updata avatar successfully',

  '旧密码': 'Oldpassword',
  '新密码': 'Newpassword',
  '确认新密码': 'Newpassword confirm',
  '旧密码不能为空': 'Oldpassword dont empty',
  '新密码不能为空': 'Newpassword dont empty',
  '确认密码不能为空': 'Confirm newpassword  dont empty',
  '密码更新成功': 'Updata password successfully'
}
